import { render, staticRenderFns } from "./VSidesheet.vue?vue&type=template&id=2aabf35d&scoped=true&"
import script from "./VSidesheet.vue?vue&type=script&lang=js&"
export * from "./VSidesheet.vue?vue&type=script&lang=js&"
import style0 from "./VSidesheet.vue?vue&type=style&index=0&id=2aabf35d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aabf35d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aabf35d')) {
      api.createRecord('2aabf35d', component.options)
    } else {
      api.reload('2aabf35d', component.options)
    }
    module.hot.accept("./VSidesheet.vue?vue&type=template&id=2aabf35d&scoped=true&", function () {
      api.rerender('2aabf35d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/addresses/components/VSidesheet.vue"
export default component.exports